module.exports = __webpack_public_path__ + "static/img/logo_certificacion_ctpat.7049529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo_certificacion_ctpat.png
// module id = 105
// module chunks = 0